/**
 * The scale finger-number display setting: the reference fingering drawn on every note of a
 * scale run (Show, the default) or not at all (Hide). Display only: fingering is never graded.
 */

import {
  DEFAULT_FINGER_NUMBERS_DISPLAY,
  FINGER_NUMBERS_DISPLAYS,
  type FingerNumbersDisplay,
} from 'Seeds/ExerciseContent/scaleFingering';

export const FINGER_NUMBERS_DISPLAY_LABELS: Record<FingerNumbersDisplay, string> = {
  show: 'Show',
  hide: 'Hide',
};

export const isFingerNumbersDisplay = (value: unknown): value is FingerNumbersDisplay =>
  typeof value === 'string' && FINGER_NUMBERS_DISPLAYS.includes(value as FingerNumbersDisplay);

/** The setting from anything read back from storage: the default when unreadable. */
export const normalizeFingerNumbersDisplay = (raw: unknown): FingerNumbersDisplay =>
  isFingerNumbersDisplay(raw) ? raw : DEFAULT_FINGER_NUMBERS_DISPLAY;
